import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"

import {
  Row,
  Col,
  CardBody,
  Card,
  Alert,
  Container,
  Form,
  Input,
  FormFeedback,
  Label,
  InputGroup,
  InputGroupText,
  InputGroupAddon
} from "reactstrap"

import { Link, useNavigate } from "react-router-dom"
import withRouter from "components/Common/withRouter"

// import images
import profile from "assets/images/profile-img.png"
import logo from "assets/images/Logo.png"
import Swal from "sweetalert2"
import secureLocalStorage from "react-secure-storage"
import ConfigUrl, { axiosbaseurl } from "../../config"
import { notification } from "antd"
import { IoMdWarning } from "react-icons/io"
import { SiTicktick } from "react-icons/si"
import Loader from "pages/Loader"
import moment from "moment"
import { BsEyeSlash } from "react-icons/bs"
import { FaEye, FaEyeSlash } from "react-icons/fa"

const Login = props => {
  const Navigate = useNavigate()

  //meta title
  document.title = "Login | Return First Investments"

  const [Loading, setLoading] = useState(false)

  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [rememberme , setrememberme] = useState(false);
  const [show, setShow] = useState(false);
  const [Error, setError] = useState("")

  useEffect(() => {
    const Login_Creds1 = secureLocalStorage.getItem("token");
    if(Login_Creds1 !== null)
    {
      Navigate(`${ConfigUrl.appurl}dashboard`)
    }
  },[])

  const handleLogin = async () => {
    if (email && password) {
      setLoading(true)
      try {
        const response = await axiosbaseurl.post(`auth/user/login`, {
          email,
          password,
        })
        if (response?.data?.success){
          setLoading(false)
          notification.open({
            message: (
              <div className="d-flex">
                <div className="pr-10">
                  <SiTicktick className="text-success" size={22} />
                </div>
                <div>Login Successful</div>
              </div>
            ),
            description: response?.data?.message,
          })

          const userId = response.data.user.id

          secureLocalStorage.setItem("User", response?.data?.user)
          secureLocalStorage.setItem("token", response?.data?.token)

          setTimeout(() => {
            Navigate(`${ConfigUrl.appurl}`)
          }, 1000)
        } else {
          notification.error("User Not Found")
        }
      } catch (e) {
        console.log(e)
        notification.open({
          message: (
            <div className="d-flex">
              <div className="pr-10">
                <IoMdWarning className="text-danger" size={22} />
              </div>
              <div>Opps! Something went wrong.</div>
            </div>
          ),
          description: e?.response?.data?.message,
        })
        // setTimeout(() => {
        //   Navigate(`${ConfigUrl.appurl}`)
        // }, 1000)
      } finally {
        setLoading(false)
      }
    } else {
      Swal.fire({
        title: "Login Unsuccessfull",
        text: "Please Use Proper Credentials",
        icon: "error",
      })
    }
  }

  return (
    <React.Fragment>
      {Loading && <Loader />}
      <div className="account-pages">
        <Container>
          <Row className="justify-content-center">
            <Col xl={7}></Col>
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div className="bg-primary bg-soft">
                  <Row>
                    <Col xs={6}>
                      <div className="text-primary p-4">
                        <h5 className="text-dark">Welcome Back !</h5>
                        <p className="mb-0 text-dark">Sign in to continue.</p>
                      </div>
                    </Col>
                    <Col className="col-6 p-2 d-flex justify-content-end pe-3">
                      <div className="rofile-user-wid ">
                        <span className="avatar-title rounded-4 px-1 bg-light">
                          <img src={logo} alt="" className="w-100" />
                        </span>
                      </div>
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-3 bg-light">
                  <div className="p-2">
                    <Form
                      className="form-horizontal"
                      onSubmit={e => {
                        e.preventDefault()
                        handleLogin()
                        return false
                      }}
                    >
                      <div className="mb-3">
                        <Label className="form-label">
                          Email <span className="text-danger">*</span>
                        </Label>
                        <Input
                          name="email"
                          className="form-control"
                          placeholder="Enter email"
                          type="email"
                          value={email}
                          onChange={e => setEmail(e.target.value)}
                          required
                        />
                      </div>

                      <div className="mb-3">
                        <Label className="form-label">
                          Password <span className="text-danger">*</span>
                        </Label>
                        <InputGroup>
                          <Input
                            name="password"
                            style={{borderRight : "none"}}
                            value={password}
                            onChange={e => setPassword(e.target.value)}
                            type={show ? 'text' : 'password'}
                            placeholder="Enter Password"
                            required
                          />
                          <InputGroupText style={{ border : "1px solid rgba(48, 43, 103, 0.4078431373)" , borderLeft  :"none", cursor: 'pointer' , background :"white" }} onClick={() => setShow(!show)}>
                            {show ? <FaEyeSlash/> : <FaEye/>}
                          </InputGroupText>
                        </InputGroup>
                      </div>

                      <div className="form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="customControlInline"
                          onChange={(e) => setrememberme(e.target.checked)}
                          checked={rememberme}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="customControlInline"
                        >
                          Remember me
                        </label>
                      </div>

                      <div className="mt-3 d-grid">
                        <button
                          className="btn btn-primary btn-block"
                          type="submit"
                        >
                          Log In
                        </button>
                      </div>

                      <div className="mt-4 text-center">
                        <Link
                          to={`${ConfigUrl.appurl}forgot-password`}
                          className="text-dark"
                        >
                          <i className="mdi mdi-lock me-1" />
                          Forgot your password ?
                        </Link>
                      </div>
                      <div className="mt-4 text-center">
                        {moment().get("year")} ©{" "}
                        <a
                          href="https://demo.returnfirstinvestment.com/"
                          className="text-dark"
                          target="_blank"
                          rel="noreferrer"
                        >
                          Return First Investment Advisors
                        </a>
                      </div>
                    </Form>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withRouter(Login)

Login.propTypes = {
  history: PropTypes.object,
}
